var _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconTemplateNormal = function SvgIconTemplateNormal(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    fillRule: "evenodd",
    d: "M19.25 21h-6.125c-.965 0-1.75-.785-1.75-1.75v-6.125c0-.965.785-1.75 1.75-1.75h6.125c.965 0 1.75.785 1.75 1.75v6.125c0 .965-.785 1.75-1.75 1.75zm-6.125-7.875v6.125h6.122l.003-6.125h-6.125zm6.125-3.5h-6.125c-.965 0-1.75-.785-1.75-1.75V1.75c0-.965.785-1.75 1.75-1.75h6.125C20.215 0 21 .785 21 1.75v6.125c0 .965-.785 1.75-1.75 1.75zM13.125 1.75v6.125h6.122l.003-6.125h-6.125zM7.877 21H1.75C.785 21 0 20.215 0 19.25v-6.125c0-.965.785-1.75 1.75-1.75h6.127c.965 0 1.75.785 1.75 1.75v6.125c0 .965-.785 1.75-1.75 1.75zM1.75 13.125v6.125h6.124l.003-6.125H1.75zm6.127-3.5H1.75C.785 9.625 0 8.84 0 7.875V1.75C0 .785.785 0 1.75 0h6.127c.965 0 1.75.785 1.75 1.75v6.125c0 .965-.785 1.75-1.75 1.75zM1.75 1.75v6.125h6.124l.003-6.125H1.75z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconTemplateNormal, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-template-normal.36bd6374.svg";
export { ForwardRef as ReactComponent };